import { render, staticRenderFns } from "./MsgElementShare.vue?vue&type=template&id=b44763ca&scoped=true"
import script from "./MsgElementShare.vue?vue&type=script&lang=js"
export * from "./MsgElementShare.vue?vue&type=script&lang=js"
import style0 from "./MsgElementShare.vue?vue&type=style&index=0&id=b44763ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44763ca",
  null
  
)

export default component.exports